<template>
  <p
    class="text-justify"
    v-html="text"
  ></p>
</template>

<script>
  export default {
    props: ['text'],
  }
</script>
